/**
 * Format a shopping list quantity and its unit for display, e.g. "16 oz".
 *
 * ShoppingItem.Quantity is interface{} on the Go side, so a quantity reaches us
 * as either a number or a string depending on how it was entered. Both need the
 * unit appended -- an earlier version only did so for numbers, which silently
 * dropped the unit from every string quantity.
 */
export function formatQuantity(quantity, quantityType) {
  let text;

  if (typeof quantity === 'number') {
    text = quantity % 1 === 0 ? quantity.toString() : quantity.toFixed(1);
  } else if (quantity === null || quantity === undefined) {
    text = '';
  } else {
    text = String(quantity).trim();
  }

  const unit = (quantityType || '').trim();
  if (!unit) return text;

  return text ? `${text} ${unit}` : unit;
}
